export function buildFormValueMsg(event) {
    const { itemId, attribute, fieldIndex, value } = event;
    return { itemId, attribute, fieldIndex, value };
}

/**
 * In Phase 2 we do not re-serialize the next-item definition (today's
 * `serializer.serialize(nextItem)`) onto the wire. The receiver re-derives
 * fields from its own flow definition + snapshot. Slot reserved as `null`
 * for backward compatibility.
 */
export function buildFormItemMsg(event) {
    return { nextItemId: event.itemId, path: event.path, nextItem: null };
}

export function buildFormFlowMsg(event) {
    return { flowId: event.flowId };
}

export function buildFormLoopMsg(event) {
    const msg = { loopName: event.loopName, loop: event.loop };
    if (event.goStartLoop !== undefined) msg.goStartLoop = event.goStartLoop;
    return msg;
}

export function buildPersistMsg({ sessionIdPublic, sessionIdPrivate, snapshot, action }) {
    return {
        session_id_private: `${sessionIdPublic}#${sessionIdPrivate}`,
        state: snapshot,
        action,
    };
}

export function buildContractMsg({ sessionIdPublic, snapshot }) {
    if (sessionIdPublic) return { session_id_public: sessionIdPublic };
    return { state: snapshot };
}

export function parseFormValueMsg(body) {
    const { itemId, attribute, fieldIndex, value } = body;
    return { itemId, attribute, fieldIndex, value };
}

export function parseFormItemMsg(body) {
    if (body.pathItem) {
        return { itemId: body.pathItem.itemId, path: body.path || [], pathItem: body.pathItem };
    }
    return { itemId: body.nextItemId, path: body.path || [], pathItem: null };
}

export function parseFormFlowMsg(body) {
    return { flowId: body.flowId };
}

export function parseFormLoopMsg(body) {
    const out = { loopName: body.loopName, loop: body.loop };
    if (body.goStartLoop !== undefined) out.goStartLoop = body.goStartLoop;
    return out;
}

export function parseSessionCreatedMsg(body) { return body; }

export function parseContractReplyMsg(body) {
    return { file: body.file, error: body.error };
}
